import React from 'react';
import photo4 from './images/4.webp';
import photo5 from './images/5.webp';
import photo6 from './images/6.webp';
import photo7 from './images/10.webp';
import photo8 from './images/9.webp';
import photo9 from './images/12.webp';
import photo10 from './images/13.webp';
import photo11 from './images/16.webp';
import photo12 from './images/15.webp';
import photo13 from './images/17.webp';
import photo14 from './images/18.webp';
import photo15 from './images/20.webp';
const Products = () => {
  return (
    <>
      <div className="container mt-5">
        <h1>Our Products</h1>
        <p>List of medicines and pharmacy items.</p>
        <div className="container my-5">
          <h3 className="text-center mb-4">Medicines</h3>
          <div className="row">
            <div className="col-md-3 mb-4">
              <div className="card h-100 d-flex flex-column">
                <img src={photo9} className="card-img-top" alt="Paracetamol" />
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">Jointace Tablet 300 mg</h5>
                  <span className="text-success fw-bold">₹350</span>
                  <a href="/product/paracetamol" className="btn btn-outline-success btn-sm mt-auto">Buy Now</a>
                </div>
              </div>
            </div>
            
            <div className="col-md-3 mb-4">
              <div className="card h-100 d-flex flex-column">
                <img src={photo5} className="card-img-top" alt="Multivitamins" />
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">Evion 400mg Strip Of 20 Capsule</h5>
                 <span className="text-success fw-bold">₹150</span>
                  <a href="/product/multivitamins" className="btn btn-outline-success btn-sm mt-auto">Buy Now</a>
                </div>
              </div>
            </div>
        
            <div className="col-md-3 mb-4">
              <div className="card h-100 d-flex flex-column">
                <img src={photo7} className="card-img-top" alt="Thermometer" />
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">Fytika Omega1000mg Bottle Of 60 Softgel Capsules</h5>
                 <span className="text-success fw-bold">₹200</span>
                  <a href="/product/thermometer" className="btn btn-outline-success btn-sm mt-auto">Buy Now</a>
                </div>
              </div>
            </div>
        
            <div className="col-md-3 mb-4">
            <div className="card h-100">
              <div className="card-body text-center d-flex flex-column justify-content-center">
                <a href="/medicines" className="btn btn-success btn-lg w-100">View All Products</a>
              </div>
            </div>
          </div>
          </div>
        </div>
        <div className="container my-5">
          <h3 className="text-center mb-4">Wellness </h3>
          <div className="row">
            <div className="col-md-3 mb-4">
              <div className="card h-100 d-flex flex-column">
                <img src={photo4} className="card-img-top" alt="Paracetamol" />
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">Depura Vitamin D3 60k Sugar Free Oral Solution 5ml</h5>
            <span className="text-success fw-bold">₹35</span>
                  <a href="/product/paracetamol" className="btn btn-outline-success btn-sm mt-auto">Buy Now</a>
                </div>
              </div>
            </div>
            
                <div className="col-md-3 mb-4">
                  <div className="card h-100 d-flex flex-column">
                    <img src={photo8} className="card-img-top" alt="Facewash" />
                    <div className="card-body d-flex flex-column">
                      <h5 className="card-title">Hashmi Hard Rock Boost Energy Capsule 20</h5>
                      <span className="text-success fw-bold">₹90</span>
                      <a href="/product/facewash" className="btn btn-outline-success btn-sm mt-auto">Buy Now</a>
                    </div>
                  </div>
                </div>
        
            <div className="col-md-3 mb-4">
              <div className="card h-100 d-flex flex-column">
                <img src={photo6} className="card-img-top" alt="Thermometer" />
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">Complan Viemax Chocolate Flavour Refill 200gm </h5>
 <span className="text-success fw-bold">₹220</span>
                  <a href="/product/thermometer" className="btn btn-outline-success btn-sm mt-auto">Buy Now</a>
                </div>
              </div>
            </div>
        
            <div className="col-md-3 mb-4">
            <div className="card h-100">
              <div className="card-body text-center d-flex flex-column justify-content-center">
                <a href="/wellness" className="btn btn-success btn-lg w-100">View All Products</a>
              </div>
            </div>
          </div>
          </div>
        </div>
        <div className="container my-5">
          <h3 className="text-center mb-4">Personal Care</h3>
          <div className="row">
            <div className="col-md-3 mb-4">
              <div className="card h-100 d-flex flex-column">
                <img src={photo10} className="card-img-top" alt="Paracetamol" />
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">Sunhalt Gold Spf 50 Tube Of 60gm Hydrating Sunscreen</h5>
                  <span className="text-success fw-bold">₹45</span>
                  <a href="/product/paracetamol" className="btn btn-outline-success btn-sm mt-auto">Buy Now</a>
                </div>
              </div>
            </div>
            
            <div className="col-md-3 mb-4">
              <div className="card h-100 d-flex flex-column">
                <img src={photo11} className="card-img-top" alt="Multivitamins" />
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">Skinnable Sunscreen Gel Spf 50+ 50 Gm</h5>
        <span className="text-success fw-bold">₹140</span>
                  <a href="/product/multivitamins" className="btn btn-outline-success btn-sm mt-auto">Buy Now</a>
                </div>
              </div>
            </div>
        
            <div className="col-md-3 mb-4">
              <div className="card h-100 d-flex flex-column">
                <img src={photo12} className="card-img-top" alt="Thermometer" />
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">Acne Uv Spf 50 Gel 50gm</h5>
<span className="text-success fw-bold">₹240</span>
                  <a href="/product/thermometer" className="btn btn-outline-success btn-sm mt-auto">Buy Now</a>
                </div>
              </div>
            </div>
        
            <div className="col-md-3 mb-4">
            <div className="card h-100">
              <div className="card-body text-center d-flex flex-column justify-content-center">
                <a href="/personal" className="btn btn-success btn-lg w-100">View All Products</a>
              </div>
            </div>
          </div>
          </div>
        </div>
        <div className="container my-5">
          <h3 className="text-center mb-4">Devices</h3>
          <div className="row">
            <div className="col-md-3 mb-4">
              <div className="card h-100 d-flex flex-column">
                <img src={photo13} className="card-img-top" alt="Paracetamol" />
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">Pharmeasy Digital Thermometer Flexi Tip</h5>
  <span className="text-success fw-bold">₹350</span>
                  <a href="/product/paracetamol" className="btn btn-outline-success btn-sm mt-auto">Buy Now</a>
                </div>
              </div>
            </div>
            
            <div className="col-md-3 mb-4">
              <div className="card h-100 d-flex flex-column">
                <img src={photo14} className="card-img-top" alt="Multivitamins" />
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">Dr. Morepen Gluco One Bg 03 Glucometer Test Strips Box Of 50</h5>
                  <span className="text-success fw-bold">₹120</span>
                  <a href="/product/multivitamins" className="btn btn-outline-success btn-sm mt-auto">Buy Now</a>
                </div>
              </div>
            </div>
        
            <div className="col-md-3 mb-4">
              <div className="card h-100 d-flex flex-column">
                <img src={photo15} className="card-img-top" alt="Thermometer" />
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">Contour Plus Glucometer Test Strips Box Of 50</h5>
                  <span className="text-success fw-bold">₹320</span>
                  <a href="/product/thermometer" className="btn btn-outline-success btn-sm mt-auto">Buy Now</a>
                </div>
              </div>
            </div>
        
            <div className="col-md-3 mb-4">
            <div className="card h-100">
              <div className="card-body text-center d-flex flex-column justify-content-center">
                <a href="/devices" className="btn btn-success btn-lg w-100">View All Products</a>
              </div>
            </div>
          </div>
          </div>
        </div>
        
      </div>
    </>
  );
};

export default Products;
